'use strict';
const angular = require('angular');

/*@ngInject*/
export function IntegrationService($resource) {
  return $resource('/api/integrations/:id', {
    id: '@_id'
  },{
    test: {
      method: 'GET',
      url: "/api/integrations/test"
    },
    queryResidentDirectory: {
      method: 'GET',
      url: "/api/integrations/resident-directory",
      isArray: true
    },
    queryServiceRequestsByUser: {
      method: 'GET',
      url: "/api/integrations/servicerequests/:email",
      isArray: true
    },
    queryServiceRequestsByWebaccessId: {
      method: 'GET',
      url: "/api/integrations/servicerequests/webaccess/:webaccessId",
      isArray: true
    },
    queryServiceRequestCodes: {
      method: 'GET',
      url: "/api/integrations/servicerequests/codes",
      isArray: true
    },
    saveServiceRequest: {
      method: 'POST',
      url: "/api/integrations/servicerequests"
    },
    deleteServiceRequest: {
      method: 'DELETE',
      url: "/api/integrations/servicerequests/:id"
    },
    patchServiceRequest: {
      method: 'PATCH',
      url: "/api/integrations/servicerequests/:id"
    },
    querySuiteLDAP: {
      method: 'GET',
      url: "/api/integrations/suite-ldap/:base/:filter",
      isArray: true
    },
    suiteChangePasswordWebAccess: {
      method: 'PUT',
      url: "/api/integrations/suite/change-password-webaccess/:webaccessId"
    },
    suiteActivatedWebAccess: {
      method: 'PUT',
      url: "/api/integrations/suite/activate-webaccess/:webaccessId"
    },
    suiteGetWebAccessEmail: {
      method: 'GET',
      url: "/api/integrations/suite/webaccess-email/:webaccessId/:token"
    },
    suiteForgotPassword: {
      method: 'PUT',
      url: "/api/integrations/suite/webaccess-forgot-password"
    },
    suiteResetPassword: {
      method: 'PUT',
      url: "/api/integrations/suite/webaccess-reset-password"
    },
    queryQuickbookBalances: {
      method: 'GET',
      isArray: true,
      url: "/api/integrations/quickbooks-balances/:propertyId"
    },
    queryProperties: {
      method: 'GET',
      isArray: true,
      url: "/api/integrations/properties/me"
    },
    getConnectedSitePage: {
      method: 'GET',
      url: "/api/integrations/connected-site/page/:url/:name"
    },
    getCalendarByType: {
      method: 'GET',
      url: "/api/integrations/calendar/:type",
      isArray: true
    },
    getNews: {
      method: 'GET',
      url: "/api/integrations/news",
      isArray: true
    }
  });
}


export default angular.module('conduuApp.IntegrationService', [])
  .factory('IntegrationService', IntegrationService)
  .name;



// WEBPACK FOOTER //
// ./client/services/integration/integration.service.js